import React from 'react'

import CarruselSinDescripcion from '../carrusel/CarruselSinDescripcion'

const PlanoMacrolote = ({mapas, english}) => {
    
    return (
        <div id="planos" >
            <h1 className="titulo" style={{marginBottom: 15}}>{english ? 'BLUEPRINTS' : 'Planos'}</h1>
            <div className="subcabecera">
                <p className="descripcion-seccion">
                    {english ? 
                            'Below are the plans delimiting the macro lot.' 
                        : 
                            'A continuación se muestran los planos delimitando el macrolote'
                    }                    
                </p>
            </div>
            <CarruselSinDescripcion imgs={mapas} />
        </div>
    )
}

export default PlanoMacrolote